<template>
  <div class="preview-ecircular">
    <modal
      ref="previewModal"
      :modalId="modalId"
      :modalType="'large-modal'"
      :beforeCloseModal="beforeCloseModal"
    >
      <div slot="content">
        <div class="preview-ecircular__basic">
          <div v-if="!isVendorEcircular">
            <div class="basic-item">
              <label class="basic-item__label">{{ $t('eCircular.building') }}:</label>
              <span class="basic-item__value">{{ (currentECircular.buildings || []).join(',') }}</span>
            </div>
            <div class="basic-item">
              <label class="basic-item__label">{{ $t('eCircular.category') }}:</label>
              <span class="basic-item__value">{{ getDisplayCategory(currentECircular.category) }}</span>
            </div>
          </div>
          <div class="basic-item">
            <label class="basic-item__label">{{ $t('from') }}:</label>
            <span class="basic-item__value">{{ $t('eCircular.hkCircular') }}</span>
          </div>

          <div v-if="previewType===PREVIEW_TYPES.SEND">
            <div
              id="eCircularBccGroup"
              class="basic-item e-circular-bcc-group"
            >
              <label
                for="e-circular-bcc"
                class="basic-item__label"
              >
                {{ $t('bcc') }}:
              </label>
              <textarea
                id="e-circular-bcc"
                v-hkldinput
                v-autosize
                v-fusioninputcheck="{
                  type: 'string',
                  tip: invalidEmailTip,
                  pattern: validateEmails,
                  classes: 'tooltip-class',
                  required: bccString.trim()
                }"
                class="autosize basic-item__value basic-item__value--input"
                :value="bccString"
                :required="bccString.trim()"
                @change="event => updateBcc(event.target.value)"
              />
            </div>
          </div>

          <div
            id="eCircularResendGroup"
            class="e-circular-resend-group"
          >
            <template
              v-if="previewType===PREVIEW_TYPES.RESEND"
            >
              <div class="basic-item e-circular-to-group">
                <label
                  for="e-circular-to"
                  class="basic-item__label"
                >
                  {{ $t('to') }}:
                </label>
                <textarea
                  id="e-circular-to"
                  v-model="resendTo"
                  v-hkldinput
                  v-autosize
                  v-fusioninputcheck="{
                    type: 'string',
                    tip: invalidEmailTip,
                    pattern: validateEmails,
                    classes: 'tooltip-class',
                    required: true
                  }"
                  class="autosize basic-item__value basic-item__value--input"
                  :required="true"
                />
              </div>
              <div class="basic-item e-circular-bcc-group">
                <label
                  for="e-circular-bcc"
                  class="basic-item__label"
                >
                  {{ $t('bcc') }}:
                </label>
                <textarea
                  id="e-circular-bcc"
                  v-model="resendBcc"
                  v-hkldinput
                  v-autosize
                  v-fusioninputcheck="{
                    type: 'string',
                    tip: invalidEmailTip,
                    pattern: validateEmails,
                    classes: 'tooltip-class',
                    required: resendBcc.trim()
                  }"
                  class="autosize basic-item__value basic-item__value--input"
                  :required="resendBcc.trim()"
                />
              </div>
            </template>

            <div class="basic-item subject">
              <label class="basic-item__label">{{ $t('eCircular.subject') }}:</label>
              <textarea
                v-hkldinput
                v-autosize
                v-fusioninputcheck="{
                  type: 'string',
                  required: true
                }"
                class="autosize basic-item__value basic-item__value--input"
                :value="currentECircular.subject"
                @input="$event => updateAttribute('subject', $event.target.value)"
              />
            </div>
          </div>
        </div>

        <div class="preview-ecircular__bk-line" />

        <div class="preview-ecircular__content">
          <ECircularPreviewIndex />
        </div>

        <div class="preview-ecircular__bk-line" />

        <div
          v-if="ecircularDocs.length"
          class="preview-ecircular__attachments"
        >
          <label class="attchments__label">{{ $t('eCircular.attachments') }}</label>
          <EditAttachments
            :canEdit="false"
            :canDelete="false"
            :sourceId="currentECircular.id"
            :canDownloadAll="true"
            :zipName="`${currentECircular.subject}_eCircular_Documents.zip`"
          />
        </div>

        <div
          v-if="previewType===PREVIEW_TYPES.SEND"
          class="preview-ecircular__recipients"
        >
          <label class="recipients__label">{{ $t('eCircular.ecircularSentToTenants', [isVendorEcircular ? $t('eCircular.options.vendor').toLowerCase() : $t('eCircular.options.tenant').toLowerCase()]) }}</label>
          <SelectRecipients
            ref="preview-recipients"
            :addedRecipients="addedRecipients"
            :operate="'VIEW'"
            :showMarketingType="isMarketingECircular"
          />
        </div>
      </div>
      <div
        v-if="previewType===PREVIEW_TYPES.SEND"
        slot="btns"
      >
        <button
          class="preview__send-test btn btn--darkblue"
          @click="openTestModal()"
        >
          {{ $t('action.testEmail') }}
        </button>
        <button
          class="preview__send-send btn btn--orange"
          :disabled="!addedRecipientsCount"
          @click="openSendModal()"
        >
          {{ $t('action.send') }}
        </button>
      </div>
      <div
        v-else-if="previewType===PREVIEW_TYPES.RESEND"
        slot="btns"
      >
        <button
          class="preview__send-send btn btn--orange"
          :disabled="!resendRecipientsCount"
          @click="resendECircular()"
        >
          {{ $t('action.resend') }}
        </button>
      </div>
    </modal>

    <modal
      ref="testEcircularModal"
      data-multiple-opened="true"
      :modalId="testModalId"
      :beforeCloseModal="beforeCloseModal"
    >
      <div
        id="eCircularTestGroup"
        slot="content"
        class="test-ecircular e-circular-test-group"
      >
        <div class="test-ecircular__label">
          {{ $t('eCircular.inputTestEmail') }}
        </div>
        <textarea
          id="e-circular-test"
          v-model="testEmail"
          v-hkldinput
          v-autosize
          v-fusioninputcheck="{
            type: 'string',
            tip: invalidEmailTip,
            pattern: validateEmails,
            classes: 'tooltip-class',
            required: true
          }"
          class="autosize test-ecircular__input"
          :required="true"
        />
      </div>
      <div slot="btns">
        <button
          class="btn btn--darkblue"
          @click="closeTestModal()"
        >
          {{ $t('action.cancel') }}
        </button>
        <button
          class="btn btn--orange"
          @click="testEcircular()"
        >
          {{ $t('action.sendTestEmail') }}
        </button>
      </div>
    </modal>

    <modal
      v-if="previewType===PREVIEW_TYPES.SEND"
      ref="sendEcircularModal"
      :modalId="sendModalId"
      :modalType="'medium-modal'"
    >
      <div
        slot="content"
        class="send-ecircular"
      >
        <div class="send-ecircular__label">
          {{ $t('eCircular.areYouSureToSend') }}
        </div>

        <div class="send-ecircular__hint count">
          <span class="count__number">{{ addedRecipients.length }}</span>
          <span class="count__label count__label--organization">{{ $t('eCircular.organizations') }}</span>
          <span class="count__number">{{ addedRecipientsCount }}</span>
          <span class="count__label">{{ $t('eCircular.recipientsWillReceiveThis') }}</span>
        </div>

        <div class="send-ecircular__options">
          <div class="radio-item">
            <input
              :id="sendNow"
              v-hkldinput
              name="send-now"
              type="radio"
              class="radioClass"
              :checked="sendOption === SEND_OPTIONS.SEND_NOW"
              @change="updateSendOptionRadio(SEND_OPTIONS.SEND_NOW)"
            >
            <label
              class="radio-label"
              :for="sendNow"
            >
              {{ $t('eCircular.sendNow') }}
            </label>
          </div>
          <div class="radio-item">
            <input
              :id="sendAsScheduled"
              v-hkldinput
              name="send-as-schedule"
              type="radio"
              class="radioClass"
              :checked="sendOption === SEND_OPTIONS.SEND_AS_SCHEDULE"
              @change="updateSendOptionRadio(SEND_OPTIONS.SEND_AS_SCHEDULE)"
            >
            <label
              class="radio-label"
              :for="sendAsScheduled"
            >
              {{ $t('eCircular.sendAsScheduleTime') }}
            </label>
          </div>
        </div>
        <div class="send-ecircular__schedule">
          <label class="schedule-label">{{ $t('eCircular.scheduleDateTime') }}</label>
          <DateTimeSelector
            :key="timestamp"
            :timeOptions="scheduleTimeOptions"
            :date="currentECircular.scheduleDate"
            :showClearBtn="true"
            :setMinTime="true"
            :disabledDates="{to: yesterday}"
            :disabled="sendOption !== SEND_OPTIONS.SEND_AS_SCHEDULE"
            @updateDate="updateScheduleDate"
            @update:partialSelected="updateTimeOptions"
          />
        </div>
      </div>
      <div slot="btns">
        <button
          class="btn btn--darkblue"
          @click="closeSendModal()"
        >
          {{ $t('action.cancel') }}
        </button>
        <button
          class="btn btn--orange"
          :disabled="!isCanConfirmSend"
          @click="sendEcircular()"
        >
          {{ $t('action.yes') }}
        </button>
      </div>
    </modal>

    <modal
      ref="afterSendEcircularMoal"
      :modalId="sentModalId"
      :modalType="'small-modal'"
    >
      <div
        slot="content"
        class="ecircular-result"
      >
        <div class="ecircular-result__label">
          {{ sendOption === SEND_OPTIONS.SEND_AS_SCHEDULE ? $t('eCircular.ecircularScheduledSuccessfully') : $t('eCircular.ecircularSentSuccessfully') }}
        </div>
      </div>
      <div slot="btns">
        <button
          class="btn btn--orange"
          @click="closeAfterSendMoal()"
        >
          {{ $t('action.ok') }}
        </button>
      </div>
    </modal>
  </div>
</template>

<script>
import lodash from 'lodash'
import mutationTypes from '@/store/mutation-types'
import { mapGetters, mapActions, mapMutations } from 'vuex'

import EditAttachments from '@/controls/EditAttachments'
import DateTimeSelector from '@/controls/DateTimeSelector'
import Modal from '@/controls/Modal'
import ECircularPreviewIndex from './ECircularViews/ECircularPreviewIndex'
import SelectRecipients from './SelectRecipients'

import * as regex from '@/utils/regex'
import * as ecircularAPI from '@/api/ecircular/request'
import i18n from '@/utils/i18n'
import dateUtil from '@/utils/dateUtil'
import notification from '@/utils/notification'
import { E_CIRCULAR_TYPES, E_CIRCULAR_STATUS, RECIPIENT_TYPES, PREVIEW_TYPES, SEND_OPTIONS } from './consts'
import { fusionInputCheckUtil } from '@/plugin/FusionInputCheck'
import { utils as formUtils } from '@/plugin/InputChange'

export default {
  name: 'PreviewEcircular',
  components: {
    Modal,
    DateTimeSelector,
    ECircularPreviewIndex,
    SelectRecipients,
    EditAttachments,
  },
  props: {
    previewType: {
      type: String,
      default: PREVIEW_TYPES.SEND,
    },
  },
  data () {
    const modalId = `previewECircular-${new Date().getTime()}-${Math.floor(Math.random() * 1000)}`
    const testModalId = `testModal-${new Date().getTime()}-${Math.floor(Math.random() * 1000)}`
    const sendModalId = `sendModal-${new Date().getTime()}-${Math.floor(Math.random() * 1000)}`
    const sentModalId = `afterSendModal-${new Date().getTime()}-${Math.floor(Math.random() * 1000)}`

    return {
      modalId,
      testModalId,
      sendModalId,
      sentModalId,
      testEmail: '',
      emailSeparator: ';',
      yesterday: new Date((new Date()).getTime() - dateUtil.ONE_DAY_MILLI),
      PREVIEW_TYPES,
      resendTo: '',
      resendBcc: '',
      scheduleTimeOptions: [],
      timestamp: '',
      sendOption: '',
      SEND_OPTIONS,
      sendNow: `sendNow${new Date()}`,
      sendAsScheduled: `sendAsScheduled${new Date()}`,
      invalidEmailTip: this.$t('hint.inputTip.email'),
    }
  },
  async mounted () {
    this.timestamp = new Date().getTime()
    this.scheduleTimeOptions = dateUtil.getTimeOptions(this.currentECircular.scheduleDate || new Date())
  },
  methods: {
    ...mapActions('ecircular', [
      'updateECircular',
      'loadECircular',
      'updateECircularAllInfo',
    ]),
    ...mapMutations('ecircular', {
      refreshCurrentECircular: mutationTypes.ECIRCULAR_CURRENT,
      updateECircularOneAttribute: mutationTypes.ECIRCULAR_UPDATE_ONE_ATTRIBUTE,
      updateECircularHistoryByPath: mutationTypes.ECIRCULAR_UPDATE_HISTORY_FIELD_PATH,
    }),
    updateAttribute (name, value) {
      this.updateECircularOneAttribute({name, value})
    },
    open () {
      this.$refs.previewModal.open()
    },
    close () {
      this.$refs.previewModal.close()
    },
    updateScheduleDate (date) {
      this.updateAttribute('scheduleDate', date)
      this.scheduleTimeOptions = dateUtil.getTimeOptions(date || new Date())
    },
    updateTimeOptions ([selectedDate, selectedTime]) {
      if (selectedDate && !selectedTime) {
        const date = new Date(dateUtil.parse(selectedDate))
        this.scheduleTimeOptions = dateUtil.getTimeOptions(date)
      }
    },
    validateSubject () {
      fusionInputCheckUtil.validateAllFields(undefined, '.basic-item.subject')
      return fusionInputCheckUtil.isAllFieldsValid('.basic-item.subject')
    },
    async openTestModal () {
      if (!this.validateBcc() || !this.validateSubject()) return
      await ecircularAPI.persistRecipientsSelection(this.currentECircular)
      await this.updateECircularSubject()
      this.testEmail = ''
      this.$refs.testEcircularModal.open()
    },
    closeTestModal () {
      this.$refs.testEcircularModal.close()
    },
    async testEcircular () {
      if (!this.validateTestTo()) return
      await ecircularAPI.sendTestMail(this.currentECircular.id, {
        to: this.testEmail,
      })
      this.closeTestModal()
      formUtils.resetDirty()
    },
    async updateECircularSubject () {
      return this.updateECircular({
        id: this.currentECircular.id,
        name: 'subject',
        value: this.currentECircular.subject,
      })
    },
    async openSendModal () {
      if (!this.validateRecipients()) {
        notification.warn(i18n.t('hint.addRecipients'))
        return
      }
      if (!this.validateSubject()) {
        return
      }
      await ecircularAPI.persistRecipientsSelection(this.currentECircular)
      await this.updateECircularSubject()
      formUtils.resetDirty()
      this.close()
      this.$refs.sendEcircularModal.open()
    },
    closeSendModal () {
      this.$refs.sendEcircularModal.close()
    },
    updateSendOptionRadio (option) {
      this.sendOption = option
      if (option === SEND_OPTIONS.SEND_NOW) {
        this.updateScheduleDate(null)
      }
    },
    async sendEcircular () {
      await ecircularAPI.persistRecipientsSelection(this.currentECircular)
      await this.updateECircularAllInfo()
      formUtils.resetDirty()

      const status = this.sendOption === SEND_OPTIONS.SEND_AS_SCHEDULE ? E_CIRCULAR_STATUS.SCHEDULED : E_CIRCULAR_STATUS.SENT
      await ecircularAPI.updateECircularStatus(this.currentECircular.id, status)
      await this.loadECircular(this.currentECircular.id)
      await ecircularAPI.sendMail(this.currentECircular.id, this.currentECircular.histories[0].id)

      this.closeSendModal()
      this.openAfterSendModal()
    },
    openAfterSendModal () {
      this.$refs.afterSendEcircularMoal.open()
    },
    closeAfterSendMoal () {
      this.$refs.afterSendEcircularMoal.close()
      this.$router.goBack()
    },
    async resendECircular () {
      if (!this.validateEmailInputs('#eCircularResendGroup', '.e-circular-resend-group') || !this.validateSubject()) {
        return
      }

      const toRecipients = this.splitEmails(this.resendTo).map(email => {
        return {
          email: email,
          type: RECIPIENT_TYPES.TO,
        }
      })
      const bccRecipients = this.splitEmails(this.resendBcc).map(email => {
        return {
          email: email,
          type: RECIPIENT_TYPES.BCC,
        }
      })
      const standaloneRecipients = [...toRecipients, ...bccRecipients]

      await this.updateECircularSubject()
      const updatedECircular = await ecircularAPI.updateECircularStatus(this.currentECircular.id, E_CIRCULAR_STATUS.RESENT)
      this.refreshCurrentECircular(updatedECircular)

      this.updateECircularHistoryByPath({
        index: this.indexOfHistory,
        path: ['standaloneRecipients'],
        newValue: standaloneRecipients,
      })
      await ecircularAPI.persistRecipientsSelection(this.currentECircular)
      await ecircularAPI.sendMail(this.currentECircular.id, this.currentECircular.histories[0].id)
      formUtils.resetDirty()
      await this.loadECircular(this.currentECircular.id)
      this.close()
    },
    updateBcc (val) {
      const emails = this.splitEmails(val.trim())
      const addedEmails = emails.filter(item => !this.bcc.includes(item))
      const deletedEmails = this.bcc.filter(item => !emails.includes(item))
      const standaloneRecipients = lodash.cloneDeep(this.newestHistory.standaloneRecipients)

      addedEmails.forEach(email => {
        standaloneRecipients.push({ type: RECIPIENT_TYPES.BCC, email: email })
      })

      deletedEmails.forEach(email => {
        standaloneRecipients.forEach((item, index) => {
          if (item.type === RECIPIENT_TYPES.BCC && item.email === email) {
            standaloneRecipients.splice(index, 1)
          }
        })
      })
      this.updateECircularHistoryByPath({
        index: this.indexOfHistory,
        path: ['standaloneRecipients'],
        newValue: standaloneRecipients,
      })
    },
    splitEmails (emailStr) {
      return (emailStr || '').split(this.emailSeparator).map(email => email.trim()).filter(item => item !== '')
    },
    validateRecipients () {
      return !!this.addedRecipients.length
    },
    validateEmails (emailStr) {
      this.invalidEmailTip = this.$t('hint.inputTip.email')
      if (this.splitEmails(emailStr).every(mail => mail === '' || regex.email.test(mail))) {
        return true
      } else if (emailStr.indexOf(',') !== -1 || emailStr.indexOf(' ') !== -1) {
        this.invalidEmailTip = this.$t('hint.inputTip.emailSemiColon')
        return false
      }
      return false
    },
    validateBcc () {
      fusionInputCheckUtil.validateAllFields(undefined, '#eCircularBccGroup')
      return fusionInputCheckUtil.isAllFieldsValid('.e-circular-bcc-group')
    },
    validateTestTo () {
      fusionInputCheckUtil.validateAllFields(undefined, '#eCircularTestGroup')
      return fusionInputCheckUtil.isAllFieldsValid('.e-circular-test-group')
    },
    validateEmailInputs (idString, classString) {
      fusionInputCheckUtil.resetAllFields()
      fusionInputCheckUtil.validateAllFields(undefined, idString)
      return fusionInputCheckUtil.isAllFieldsValid(classString)
    },
    beforeCloseModal () {
      fusionInputCheckUtil.resetAllFields()
      formUtils.resetDirty()
    },
    getDisplayCategory (category) {
      return lodash.get(category, 'shortname')
    },
  },
  computed: {
    ...mapGetters('ecircular', ['currentECircular', 'addedRecipients']),
    isMarketingECircular () {
      return this.currentECircular.category.department && this.currentECircular.category.department.shortname === 'MC'
    },
    ecircularDocs () {
      return lodash.orderBy(this.currentECircular.files, 'order')
    },
    addedRecipientsCount () {
      let count = 0
      this.addedRecipients.forEach(item => {
        count += item.recipients.length
      })
      return count
    },
    newestHistory () {
      // ecircular.histories[0] is lastest history
      if (this.currentECircular.histories && this.currentECircular.histories.length > 0) {
        const histories = lodash.orderBy(this.currentECircular.histories, 'createdAt').reverse()
        return histories[0]
      }
      return {}
    },
    isVendorEcircular () {
      return this.currentECircular.type === E_CIRCULAR_TYPES.VENDOR
    },
    indexOfHistory () {
      let indexOf = null
      this.currentECircular.histories.forEach((item, index) => {
        if (item.id === this.newestHistory.id) {
          indexOf = index
        }
      })
      return indexOf
    },
    bcc () {
      let bcc = []
      if (this.newestHistory.standaloneRecipients && this.newestHistory.standaloneRecipients.length > 0) {
        const bccRecipients = this.newestHistory.standaloneRecipients.filter(item => item.type === RECIPIENT_TYPES.BCC)
        bcc = bccRecipients.map(item => item.email)
      }
      return bcc
    },
    bccString () {
      return this.bcc.reduce((result, email) => {
        const prefix = result === '' ? '' : this.emailSeparator
        return result.concat(prefix).concat(email)
      }, '')
    },
    resendRecipientsCount () {
      return this.splitEmails(this.resendTo).length
    },
    isCanConfirmSend () {
      return this.sendOption === SEND_OPTIONS.SEND_NOW ||
        (this.sendOption === SEND_OPTIONS.SEND_AS_SCHEDULE &&
          this.currentECircular.scheduleDate &&
          (new Date(this.currentECircular.scheduleDate) > new Date()))
    },
  },
}
</script>

<style lang="scss" scoped>
.preview-ecircular {
  &__basic {
    .basic-item {
      display: flex;
      align-items: baseline;
      &:not(:last-child) {
        margin-bottom: 15px;
      }
      &:last-child {
        margin-bottom: 10px;
      }
      &__label {
        display: inline-block;
        font-size: 14px;
        font-weight: bold;
        color: #0c3a58;
        width: 85px;
        margin-right: 20px;
      }

      &__value {
      font-size: 16px;
        &--input {
          display: inline;
          border: solid 1px #B5B5B5;
          font-size: 14px;
          min-height: 20px;
          overflow: hidden;
          padding-left: 10px;
          color: #0c3a58;
          flex: 1;
          line-height: 1.43;
        }
      }
      & ::v-deep .text-input {
        margin: 0;
      }
    }
  }

  &__bk-line {
    border-bottom: 2px solid #ededed;
    margin: 0 -30px;
    margin-bottom: 15px;
  }

  &__content {
    margin-bottom: 15px;
  }

  &__attachments {
    margin-bottom: 15px;
    .attchments {
      &__label {
        font-size: 14px;
        font-weight: bold;
        color: #0c3a58;
        margin-bottom: 15px;
      }

      &__list {
        list-style: none;
        margin: 0;
      }

      &__item {
        box-sizing: border-box;
        border: solid 1px #ededed;
        padding: 15px 12px 15px 12px;

        &:nth-child(odd) {
          background-color: #fbfbfb;
        }
        &:not(:last-child) {
          border-bottom: none;
        }
      }

      &__item-order {
        color: #004467;
        margin-right: 10px;
      }

      &__item-link {
        color: #004467;
        text-decoration: underline;
      }
    }
  }

  &__recipients {
    margin-bottom: 20px;
    .recipients {
      &__label {
        font-size: 14px;
        font-weight: bold;
        color: #0c3a58;
        margin-bottom: 15px;
      }
    }
  }
}

.popup-hint-label {
  font-size: 14px;
  font-weight: bold;
  color: #0c3a58;
  margin-bottom: 15px;
}
.test-ecircular {
  &__label {
    @extend .popup-hint-label;
  }
  &__input {
    box-sizing: border-box;
    min-height: 20px;
    height: 40px;
    font-size: 14px;
    color: #0c3a58;
    line-height: 1.43;
  }
}

.send-ecircular {
  &__label {
    @extend .popup-hint-label;
  }

  &__hint {
    display: flex;
    align-items: center;
    margin-bottom: 20px;
    .count {
      &__number {
        margin-right: 5px;
        border-radius: 10px;
        background-color: #083e62;
        color: #fff;
        font-weight: bold;
        padding: 2px 8px;
      }
      &__label {
        &--organization {
          margin-right: 7px;
        }
      }
    }
  }

  &__schedule {
    .schedule-label {
      font-size: 14px;
      font-weight: bold;
      font-style: normal;
      color: #0C3A58;
      margin-bottom: 5px;
    }
  }

}

.ecircular-result {
  &__label {
    @extend .popup-hint-label;
  }
}
</style>
